<template>
  <div>
    <v-card class="mx-auto mb-8 pa-4 d-flex flex-column justify-start align-center" elevation="3">
      <CustomScenarioChart :period="otherValues.lifeExpectancy" category="age" />
    </v-card>
    <EstimatedCashFlowSavings />
    <EquityChange />
    <Summary />
  </div>
</template>

<script>
import CustomScenarioChart from '../../Charts/CustomScenarioChart.vue';
import EstimatedCashFlowSavings from '../EstimatedCashFlowSavings.vue';
import EquityChange from '../EquityChange.vue';
import Summary from '../../Summary/index.vue';

export default {
  components: {
    CustomScenarioChart,
    EstimatedCashFlowSavings,
    EquityChange,
    Summary
  },
  computed: {
    otherValues() {
      return this.$store.state.scenarioData.currentScenarioData.finalValues.otherValues;
    }
  },
}

</script>

<style></style>
